import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useForm, ValidationError } from '@formspree/react';
import { FiSend, FiCheckCircle } from 'react-icons/fi';

const Contact = () => {
  const [state, handleSubmit] = useForm(process.env.REACT_APP_FORMSPREE_FORM_ID);

  const inputClasses = "w-full bg-transparent text-text-primary focus:outline-none";

  const formVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  };

  return (
    <section id="contact" className="bg-black grainy py-24 sm:py-32 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-text-primary text-center mb-12 font-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Get In Touch
        </motion.h2>

        <motion.div
          className="bg-[#111111] rounded-2xl border border-white/10 overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        >
          {/* AnimatePresence will manage the transition between the form and the success message */}
          <AnimatePresence mode="wait">
            {state.succeeded ? (
              <motion.div
                key="success"
                variants={formVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                className="p-6 text-center"
              >
                <FiCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
                <h3 className="text-2xl font-bold text-text-primary font-heading">Thank You!</h3>
                <p className="text-text-secondary mt-2">Your message has been sent successfully. I'll get back to you shortly.</p>
              </motion.div>
            ) : (
              <motion.form
                key="form"
                variants={formVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                onSubmit={handleSubmit}
                className="p-6"
              >
                <div className="flex items-center gap-4 py-2 border-b border-white/10">
                  <span className="text-text-secondary">To:</span>
                  <span className="text-text-primary font-medium">Dheeraj Reddy</span>
                </div>
                <div className="flex items-center gap-4 py-2 border-b border-white/10 focus-within:border-accent transition-colors">
                  <label htmlFor="name" className="text-text-secondary">From:</label>
                  <input type="text" id="name" name="name" required placeholder="Your Name" className={inputClasses}/>
                </div>
                <div className="flex items-center gap-4 py-2 border-b border-white/10 focus-within:border-accent transition-colors">
                  <label htmlFor="email" className="text-text-secondary">Email:</label>
                  <input type="email" id="email" name="email" required placeholder="your.email@example.com" className={inputClasses}/>
                  <ValidationError prefix="Email" field="email" errors={state.errors} className="text-red-500 text-xs"/>
                </div>

                <textarea
                  id="message" name="message" required
                  placeholder="Hi Dheeraj, I'd like to talk about..."
                  className="w-full bg-transparent text-text-primary focus:outline-none mt-6 min-h-[150px] resize-none"
                />
                
                <div className="mt-6 flex justify-end">
                  <motion.button
                    type="submit"
                    disabled={state.submitting}
                    className="bg-accent text-text-primary font-bold py-3 px-6 rounded-lg flex items-center gap-2 disabled:opacity-50"
                    whileHover={{ scale: state.submitting ? 1 : 1.05 }}
                    whileTap={{ scale: state.submitting ? 1 : 0.95 }}
                  >
                    {state.submitting ? 'Sending...' : 'Send Message'} <FiSend />
                  </motion.button>
                </div>
              </motion.form>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;